import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    if (slug) {
      axios
        .get(`https://dropshopi.com/api/get-blog-by-slug.php?slug=${slug}`)
        .then((res) => {
          if (res.data.status === 'success') {
            setBlog(res.data.data);
          }
        })
        .catch((err) => {
          console.error('Failed to fetch blog:', err);
        });
    }
  }, [slug]);

  if (!blog) {
    return <div className="text-white text-center mt-5">Loading blog...</div>;
  }

  return (
    <div className="bg-black text-white items-center container-fluid">
  

      {/* Blog detail */}
      <div className="container py-5 mt-5">


<div className='row g-1'>
    <div className='col-md-8'>

        <h2 class="display-3 fw-bold anton ft3 mt-4 mb-4"  > 
            <br/><span class="text-warning2">{blog.title}</span></h2>
 

        {blog.featured_image && (
          <div className="mb-4">
            <img
              src={blog.featured_image}
              alt={blog.alt_text || "Blog image"}
              className="img-fluid rounded"
              style={{ maxHeight: "400px", objectFit: "cover" }}
            />
          </div>
        )}

        <div
          className="blog-content  text-white"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />

        
    </div>
    <div className='col-md-4'>


        <div className="bg-black text-white  " style={{position: "sticky", top: "90px"}}>
        <Container className="d-flex justify-content-center align-items-center ">
          <div className="box-container2">
            <div className="strategy-card text-center px-1 pb-4">
              <h1 className="display-3 fw-bold anton ft5 mt-4">
                Ready to test our<br /> <span className="text-warning2">NEXT LEVEL STRATEGY?</span> 
              </h1>
              <p className=" mt-4  " style={{fontSize:"13px",}}>
                If you want to achieve ground-breaking growth with increased sales and profitability with paid ads, then you're in the right place.
              </p>
              <Link to="/contact" className="btn-purple mb-4 mt-4">
                Book Your Free Strategic Call <span>&#9889;</span>
              </Link>
            </div>
          </div>
        </Container>
      </div>



    </div>
</div>

        {/* strategy */}
      <div className="bg-black text-white py-2 mb-1 mt-1">
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
          <div className="box-container">
            <div className="strategy-card text-center px-4">
              <h1 className="display-3 fw-bold anton ft3 mt-4">
                Ready to Experience Game-Changing Growth?<br />
                Put Our <span className="text-warning2">NEXT LEVEL STRATEGY</span> to the Test
              </h1>
              <p className="text-secondary mt-4 fs-5 fw-medium">
                <span className="text-warning2"><span>&#9889;</span> Limited Spots Available - </span>
                We only work with entrepreneurs who<br />
                are ready to <strong>scale and maximise ROAS</strong>.
                Don’t miss this<br /> opportunity – book your session today!
              </p>
              <Button variant="primary" className="btn-purple mb-4 mt-4">
                Book Your Free Strategic Call <span>&#9889;</span>
              </Button>
            </div>
          </div>
        </Container>
      </div>

      </div>
    </div>
  );
}
